<div class="app-container" data-cy="not-found-page">
  <page-header [title]="'title.not-found'" [fullWidthPageTitle]="true"></page-header>

  <section class="content not-found-content">
    <div class="not-found-panel">
      <div class="not-found-code" aria-hidden="true">404</div>
      <h2 data-cy="not-found-heading">{{ 'not-found.heading' | translate }}</h2>
      <p data-cy="not-found-description">{{ 'not-found.description' | translate }}</p>
      <btn
        [label]="'not-found.home'"
        [icon]="'fas-house'"
        [classes]="['btn-first']"
        [dataCyAttribute]="'not-found-home'"
        (onEvent)="goHome()"
      ></btn>
    </div>
  </section>
</div>
